import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "workload-update-modal" }
const _hoisted_2 = { class: "row mt-3 ml-6 mr-6" }
const _hoisted_3 = { class: "row ml-6 mr-6" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "col-10" }
const _hoisted_6 = { class: "row ml-6 mr-6" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "row ml-6 mr-6" }
const _hoisted_10 = { class: "col-2" }
const _hoisted_11 = { class: "col-10" }
const _hoisted_12 = { class: "row ml-6 mr-6" }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { class: "col-10" }
const _hoisted_15 = { class: "row ml-6 mr-6 workload-update-table" }
const _hoisted_16 = { class: "name-column" }
const _hoisted_17 = { class: "quantity-column" }
const _hoisted_18 = { class: "unit-column" }
const _hoisted_19 = {
  key: 0,
  class: "note-column"
}
const _hoisted_20 = { class: "operation-column" }
const _hoisted_21 = { class: "name-column" }
const _hoisted_22 = { class: "quantity-column" }
const _hoisted_23 = { class: "unit-column" }
const _hoisted_24 = {
  key: 0,
  class: "note-column"
}
const _hoisted_25 = { class: "operation-column" }
const _hoisted_26 = { class: "td-flex" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "add-table-row-button-area" }
const _hoisted_29 = { class: "row ml-6 mr-6 mb-6 workload-update-button-area" }
const _hoisted_30 = { class: "d-flex justify-content-end" }
const _hoisted_31 = { class: "workload-update-error-modal m-3" }
const _hoisted_32 = { class: "d-flex justify-content-end" }

import { ref } from "vue";
import "gitart-vue-dialog/dist/style.css";
import { GDialog } from "gitart-vue-dialog";
import DeliveryPlanEvent from "@/types/DeliveryPlanEvent";
import WorkloadType from "@/types/Workload"
import getWorkloadResponse from "@/types/responses/getWorkload"
import Api from "@/services/api/ApiServiceFabrick";
import { SELECT_WORK_EVENT_TYPES } from "@/services/consts";
import { useAuth } from "@/services/user/Auth0UserProvider"
import Workload from '@/services/models/Workload'
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import i18n from '@/lang/i18n';

// const

export default /*@__PURE__*/_defineComponent({
  __name: 'WorkloadUpdateModal',
  props: {
    isWaitingForSave: { type: Boolean },
    workItem: {},
    operationOfficeId: {},
    updateAuthority: { type: Boolean }
  },
  emits: ["setWorkId", "setRefuelingAmount"],
  setup(__props: any, { emit: __emit }) {

const MAX_TABLE_ROW:any = {"loading": 3, "unloading": 3, "refueling": 1}
const selectWorkEventTypes:any = SELECT_WORK_EVENT_TYPES

// reactive
const items = ref<WorkloadType[]>([]);
const selectableWorkloads = ref();
const selectableUnits = ref();

const errorMessages = ref()
const dialogState = ref(false);
const submitButtonState = ref(false);
const loadingState = ref(false);
const flashMessage = ref({
  "message": "",
  "show": false,
  "type": "info",
  "cancel": false
});

// variable
const { loginWithRedirect } = useAuth();
let workId = "";
let deleteItems:number[] = [];

const props = __props
const emit = __emit

const initModal = () => {
  items.value = [];
  deleteItems = [];
  selectableWorkloads.value = [];
  selectableUnits.value = [];
  errorMessages.value = [];
  flashMessage.value["show"] = false;
  flashMessage.value["cancel"] = true;
};
const openModal = () => {
  dialogState.value = true;
  if(!props.isWaitingForSave){
    loadingState.value = false;
    initModal();
    if(!props.workItem.work_id){
      generateWorkId()
    }else{
      workId = props.workItem.work_id
      getWorkloads(workId);
    }
  }
};
const closeModal = () => {
  dialogState.value = false;
};
const submit = () => {
  submitButtonState.value = true;
  const isValidate = Workload.validate(props.workItem.work, items.value);
  if(Object.keys(isValidate).length > 0){
    errorMessages.value = isValidate
    submitButtonState.value = false;
  }else{
    errorMessages.value = []
    setWorkloads(workId)
  }
};
const addTableRow = () => {
  let init_unit = i18n.global.t('pages.dailyReports.workloadUpdateModal.pieces');
  if(props.workItem.work == "refueling"){
    init_unit = i18n.global.t('pages.dailyReports.workloadUpdateModal.liter')
  }
  const emptyItem: WorkloadType = {
    id: null,
    work_id: workId,
    delivery_plan_id: props.workItem.delivery_plan_id,
    operation_office_id: props.operationOfficeId,
    name: "",
    quantity: null,
    unit: init_unit,
    note: null,
    updated_by: null,
    created_by: null,
  }
  items.value.push(emptyItem)
};
const removeTableRow = (item: WorkloadType, index:number) => {
  items.value.splice(index, 1);
  if(item.id != null) deleteItems.push(item.id);
  removeErrorMessageRow(index)
};
const removeErrorMessageRow = (index:number) => {
  if(Object.keys(errorMessages.value).length > 0){
    for(let i=index; i < 3; i++){
      if(i < 2){
        errorMessages.value['workloads.' + i + '.name'] = errorMessages.value['workloads.' + (i+1) + '.name']
        errorMessages.value['workloads.' + i + '.quantity'] = errorMessages.value['workloads.' + (i+1) + '.quantity']
        errorMessages.value['workloads.' + i + '.unit'] = errorMessages.value['workloads.' + (i+1) + '.unit']
        errorMessages.value['workloads.' + i + '.note'] = errorMessages.value['workloads.' + (i+1) + '.note']
      }else{
        delete errorMessages.value['workloads.' + i + '.name']
        delete errorMessages.value['workloads.' + i + '.quantity']
        delete errorMessages.value['workloads.' + i + '.unit']
        delete errorMessages.value['workloads.' + i + '.note']
      }
    }
  }
};

const generateWorkId = () => {
  Workload.generateWorkId(
    props.workItem.works[0].delivery_plan_id,
    props.workItem.works[0].work,
    props.workItem.works[0].status,
    props.workItem.works[0].date_time
  ).then((digestHex) => {
    workId = digestHex
    getWorkloads(workId);
  });
}
const getWorkloads = (workId:string) => {
  Api().getWorkloads(props.operationOfficeId, workId).then((data:getWorkloadResponse) => {
    data.workloads.map((item)=>{
      item.quantity = Number(item.quantity)
    })
    loadingState.value = true;
    items.value = data.workloads;
    selectableWorkloads.value = data.selectable_workloads;
    selectableUnits.value = data.selectable_units;
    if(items.value.length == 0){
      addTableRow()
    }
  }).catch((error:any) => {
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 500:
        flashMessage.value = {
          message: i18n.global.t('pages.dailyReports.errorMessage.getData'),
          show: true,
          type: "error",
          cancel: false
        }
        break
    }
  })
}
const setWorkloads = (workId:string) => {
  Api().upsertWorkloads(props.operationOfficeId, workId, props.workItem.works[0], items.value, deleteItems).then((data:getWorkloadResponse) => {
    data.workloads.map((item)=>{
      item.quantity = Number(item.quantity)
    })
    items.value = data.workloads;
    deleteItems = [];
    selectableWorkloads.value = data.selectable_workloads;
    selectableUnits.value = data.selectable_units;
    submitButtonState.value = false;
    emit('setWorkId', workId)
    flashMessage.value = {
      message: i18n.global.t('pages.dailyReports.messages.registered'),
      show: true,
      type: "info",
      cancel: false
    }
    setRefuelingAmount()
  }).catch((error:any) => {
    console.log(error)
    submitButtonState.value = false;
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({ appState: { targetUrl: location.pathname } })
        break
      case 403:
        location.reload()
        break
      case 422:
        errorMessages.value = res.data.errors
        break
      case 500:
        flashMessage.value = {
          message: i18n.global.t('pages.dailyReports.errorMessage.registered'),
          show: true,
          type: "error",
          cancel: false
        }
        break
    }
  })
}
const setRefuelingAmount = () => {
  if(props.workItem.works[0].work == "refueling"){
    emit('setRefuelingAmount')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.isWaitingForSave)
      ? (_openBlock(), _createBlock(_unref(GDialog), {
          key: 0,
          modelValue: dialogState.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogState).value = $event)),
          "max-width": "90%",
          transition: "custom-from-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h4", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.loadingOrRefuelingRegistration')), 1)
              ]),
              _createVNode(_component_v_divider, { class: "mt-2 mb-0" }),
              _createVNode(ModalFlashMessage, {
                message: flashMessage.value.message,
                show: flashMessage.value.show,
                type: flashMessage.value.type,
                cancel: flashMessage.value.cancel,
                onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.value.show = show})
              }, null, 8, ["message", "show", "type", "cancel"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.work')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(selectWorkEventTypes)[__props.workItem.work]), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.address')), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(__props.workItem.spot_name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.arrivalDateTime')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(__props.workItem.start_time), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.departureDateTime')), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(__props.workItem.end_time), 1)
              ]),
              _createVNode(_component_v_divider, { class: "mt-2 mb-2" }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_16, _toDisplayString(__props.workItem.work == "refueling"?
                    _unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.gasStationType') :
                    _unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.productName')), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.quantity')), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.unit')), 1),
                      (__props.workItem.work !== 'refueling')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.note')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", _hoisted_20, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.operation')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 'workload-' + index,
                        class: "tr-nohover"
                      }, [
                        _createElementVNode("td", _hoisted_21, [
                          _createVNode(_component_v_combobox, {
                            variant: "underlined",
                            items: selectableWorkloads.value,
                            modelValue: item.name,
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                            "hide-details": "auto",
                            "no-data-text": _unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.selectproductName'),
                            "error-messages": errorMessages.value?.['workloads.' + index + '.name']
                          }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "no-data-text", "error-messages"])
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createVNode(_component_v_text_field, {
                            variant: "underlined",
                            modelValue: item.quantity,
                            "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                            modelModifiers: { number: true },
                            "hide-details": "auto",
                            "error-messages": errorMessages.value?.['workloads.' + index + '.quantity']
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages"])
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          (__props.workItem.work == 'loading' || __props.workItem.work == 'unloading')
                            ? (_openBlock(), _createBlock(_component_v_combobox, {
                                key: 0,
                                variant: "underlined",
                                items: selectableUnits.value,
                                modelValue: item.unit,
                                "onUpdate:modelValue": ($event: any) => ((item.unit) = $event),
                                "hide-details": "auto",
                                "no-data-text": _unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.inputUnit'),
                                "error-messages": errorMessages.value?.['workloads.' + index + '.unit']
                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "no-data-text", "error-messages"]))
                            : (_openBlock(), _createBlock(_component_v_select, {
                                key: 1,
                                variant: "underlined",
                                items: selectableUnits.value,
                                modelValue: item.unit,
                                "onUpdate:modelValue": ($event: any) => ((item.unit) = $event),
                                "hide-details": "auto",
                                "no-data-text": _unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.inputUnit'),
                                "error-messages": errorMessages.value?.['workloads.' + index + '.unit']
                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "no-data-text", "error-messages"]))
                        ]),
                        (__props.workItem.work !== 'refueling')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                              _createVNode(_component_v_text_field, {
                                variant: "underlined",
                                modelValue: item.note,
                                "onUpdate:modelValue": ($event: any) => ((item.note) = $event),
                                "hide-details": "auto",
                                "error-messages": errorMessages.value?.['workloads.' + index + '.note']
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "error-messages"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            (props.updateAuthority)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "material-symbols-outlined remove-table-row-button",
                                  onClick: ($event: any) => (removeTableRow(item, index))
                                }, " delete ", 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (loadingState.value && items.value.length < MAX_TABLE_ROW[__props.workItem.work])
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "material-symbols-outlined add-table-row-button mt-3",
                        onClick: addTableRow
                      }, " add "))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_v_divider, { class: "mt-2 mb-2" }),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_v_btn, {
                    class: "reset-btn",
                    onClick: closeModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
                    ]),
                    _: 1
                  }),
                  (props.updateAuthority)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        loading: submitButtonState.value,
                        disabled: !loadingState.value,
                        class: "exec-btn ml-3",
                        onClick: submit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createBlock(_unref(GDialog), {
          key: 1,
          modelValue: dialogState.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogState).value = $event)),
          "max-width": "50%",
          transition: "custom-from-bottom-transition"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.workloadUpdateModal.noSaveMessage')), 1),
              _createVNode(_component_v_divider, { class: "mt-2 mb-2" }),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_v_btn, {
                  class: "reset-btn",
                  onClick: closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])),
    _createElementVNode("button", {
      class: "material-symbols-outlined box-add-button d-flex",
      onClick: openModal
    }, [
      (__props.workItem.work == 'loading' || __props.workItem.work == 'unloading')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" box_add ")
          ], 64))
        : _createCommentVNode("", true),
      (__props.workItem.work == 'refueling')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" local_gas_station ")
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})